import {Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {NetworkServerModel} from "../../models/network-server.model";
import {RFParamSetElement} from "../../models/rf-paramset-element.model";
import {Location} from '@angular/common';
import {Router} from "@angular/router";
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Output} from "@angular/core";
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {DevAddrUtils} from "../../services/devAddr-utils.service";
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false,
  selector: 'app-create-network-servers',
  templateUrl: './create-network-servers.component.html',
})

export class CreateNetworkServersComponent implements OnInit {

  public networkServerModel: NetworkServerModel;
  public rfParamSets: Array<RFParamSetElement>;
  public rfParamSetElement: RFParamSetElement;
  public noValid: boolean = false;
  public noValidNsId: boolean = false;
  public noValidSubnwkId: boolean = false;
  public devAddrRange: string = "";
  public nameExist;
  public disableName = false;
  public disableNsId = false;
  public netIdExist = false;
  public nsIdExist = false;
  public subnwkIdExist = false;
  public subnwkIdOutOfRange: boolean = false;
  public disableSaveButton = false;
  public duplicatesExist = false;
  public duplicateError = false;
  public searchText = '';
  public searchPrimaryHub = '';
  public searchSecondaryHub = '';
  public allPlatforms: any[] = [];
  public platformExists = false;
  public allNsGroups: any[] = [];
  public nsGroupExists = false;
  public authTypes: string[] = ['NoAuth', 'BasicAuth']
  public authTypeExists = false;
  public securityOptions: string[] = ['None', 'SSL']
  public securityExists = false;
  public protocolVersions: string[] = ['1.0', '1.1']
  public protocolVersionExists = false;
  public trackingPattern: any[] = [];
  public showSearch = false;
  public showPrimarySearch = false;
  public showSecondarySearch = false;
  public visibleAnimate = false;
  public hasError = false;
  public trackingArr = [];
  public trackingCheck = [];
  public validPattern;
  public username = "";
  public userId = "";
  public patternError = false;
  public urlPatternError;
  public fnsPatternError;
  public snsPatternError;
  public hnsPatternError;
  public doNotHaveNetId = true;
  public doNotHaveSubnwkId = true;
  public nsGroupNetId;
  public ownerArray:Array<string> = [];
  private value:any = {};
  public haveUrl = false;
  public validAlarm = false;
  public errorValidAlarm = false;
  public patternAlarm = false;
  public errorPatternAlarm = false;
  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  public errorClass = ["ng-pristine", "ng-invalid", "ng-touched"];

  public paramSetIdExist: boolean = false;
  public rfParamSetPanelHidden: boolean = true;

  public renderNsGroup = true;


  @Input() validationType;
  @Input() dataType;
  @ViewChild('inputNetId') inputNetId: ElementRef;
  @ViewChild('validate') validate: NgForm;

  constructor(private router: Router,
              private _location: Location,
              private http: HttpClient) {

    this.networkServerModel = new NetworkServerModel();
    this.rfParamSets = [];
    this.rfParamSetElement = new RFParamSetElement();
  }

  // Live Search functions

  public selectedOwner(value:any):void {
    this.networkServerModel.owner = value.split(",", 1)[0] ;
  }

  // Select a PrimaryHub from live search list

  public selectedPlatform(value:any):void {
    this.networkServerModel.platformId = value.split(",",1)[0];
    this.platformExists = true;
  }

  public selectedNsGroup(value:any):void {
    this.networkServerModel.nsGroupId = value.split(",",1)[0];
    this.nsGroupExists = true;
    this.getNsGroup(this.networkServerModel.nsGroupId);
    this.inputNetId.nativeElement.value = '';
    this.doNotHaveNetId = true;
  }

  public selectedAuthType(value:any): void {
    this.networkServerModel.authType = value.split(",",1)[0];
    this.authTypeExists = true;
  }

  public selectedSecurity(value: any): void {
    this.networkServerModel.security = value.split(",",1)[0];
    this.securityExists = true;
  }

  public selectedProtocolVersion(value:any): void {
    this.networkServerModel.protocolVersion = value.split(",", 1)[0];
    if (this.networkServerModel.protocolVersion === "1.0") {
      this.nsIdExist = false;
      this.noValidNsId = false;
    }
    this.protocolVersionExists = true;
  }

  public removedOwner(value:any):void {
    this.networkServerModel.owner = "";
  }

  public removedPlatform(value:any):void {
    this.networkServerModel.platformId = "";
    this.platformExists = false;
  }

  public removedNsGroup(value:any):void {
    this.networkServerModel.nsGroupId = "";
    this.nsGroupExists = false;
  }

  private hex2bin(hex: string, length: number) {
    var mask = "";
        if(hex.length == 16) {
            mask = "00000000000000000000000000000000";
            if(!length) length = 64;
        } else {
            mask = "000000000000";
            if(!length) length = 24;
        }
        //Divide the hex string to two halves and decode each half separately as parseInt hits overflow limits
        var hexAsBinaryLeft = parseInt(hex.substr(0, hex.length / 2), 16).toString(2);
        var hexAsBinaryRight = parseInt(hex.substr(hex.length / 2, hex.length /2), 16).toString(2);
        var hexAsBinaryLeftStr = (mask + hexAsBinaryLeft).substr(-mask.length);
        var hexAsBinaryRightStr = (mask + hexAsBinaryRight).substr(-mask.length);
        var binStr = (hexAsBinaryLeftStr + hexAsBinaryRightStr).substr(0, length);
        return binStr;
  }

  // Validation fields

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  validateNsId(nsId, nsIdElement) {
    // Pattern validation
    let nsIdRegExp = new RegExp(/^([0-9a-fA-F]{16})$/i);
    if (!nsIdRegExp.test(nsId) || nsId.length > 16) {
      this.noValidNsId = true;
    } else {
      this.noValidNsId = false;
    }
    if(!this.noValidNsId) {
      this.nsIdExist = false;
      // Verify if NsId exists in database
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.EXISTS_NSID;
      nsId = nsId.trim();
      var body: any = {
        "virtId": "0",
        "nsId": nsId
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.nsIdExist = data.response;
          }
        );
    }
  }

  validateName(name, nameElement) {
    this.nameExist = false;
    nameElement.classList.remove(...this.class);

    if(name.trim().length == 0){
      this.disableName = true;
      nameElement.classList.remove(this.class);
      nameElement.classList.add(this.errorClass);
    } else {
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.EXISTS_NAME;
      name = name.replace(/\s\s+/g, ' ');
      name = name.trim();
      var body = {
        "name": name,
        "type": 'NS'
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.nameExist = data.response;
          }
        );
      this.disableName = false;
      nameElement.classList.add(...this.class);
    }
  }

  // Validation for NetIds
  validateId(id, index) {
    // Pattern validation
    this.patternError = false;
    let netIdRegExp = new RegExp(/^([0-9a-fA-F]{6})\/(1[8-9]|2[0-4])$/i);
    if (!netIdRegExp.test(id)) {
      this.patternError = true;
      this.trackingPattern[index] = true;
    } else {
      this.patternError = false;
      this.trackingPattern[index] = false;
    }

    if(!this.patternError /** && this.networkServerModel.protocolVersion === "1.0" **/) {
      // Verify if NetId exists in database
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.EXISTS_NET_ID;
      var body: any = {
          "virtId": "0",
          "netId": id
        };

      this.http.post<any>(url, body, options)
        .subscribe(
          data => {
            this.trackingArr[index] = data.response;
            this.hasError = this.trackingArr[index];
          }
      );

      // Verify if exists duplicates
      var prefixLength = parseInt(id.split("/")[1]);
      var prefix = this.hex2bin(id.split("/")[0], prefixLength);
      for (let i = 0; i < this.networkServerModel.netIds.length; i++) {
        if (prefix == this.hex2bin(this.networkServerModel.netIds[i], prefixLength) && i != index) {
          this.trackingCheck[index] = true;
          break;
        } else {
          this.trackingCheck[index] = false;
        }
      }
      this.duplicateError = this.trackingCheck[index];
    }

    // Verify if exists any error
    this.disableSaveButton = false;
    for(let i in this.trackingPattern) {
      if(this.trackingPattern[i] == true) {
        this.disableSaveButton = true;
      }
    }
    for(let i in this.trackingCheck) {
      if(this.trackingCheck[i] == true) {
        this.disableSaveButton = true;
      }
    }
    for(let i in this.trackingArr) {
      if(this.trackingArr[i] == true) {
        this.disableSaveButton = true;
      }
    }
  }

  // Validation on last NetID row
  validation(inputNetId) {
    this.noValid = this.hasError = this.duplicatesExist = this.duplicateError = this.netIdExist = false;
    if(inputNetId !== '' || this.networkServerModel.netIds.length > 0) this.renderNsGroup = false
    if(inputNetId != "") {
      if(inputNetId.split("/").length == 1) inputNetId = inputNetId + '/24'
      let idRegExp = new RegExp(/^([0-9a-fA-F]{6})\/(1[8-9]|2[0-4])$/i);
      if (!idRegExp.test(inputNetId)) {
        this.noValid = true;
      } else {
        this.noValid = false;
      }
      this.hasError = this.noValid;

      if(!this.noValid /** && this.networkServerModel.protocolVersion === "1.0" **/) {
        // Verify if NetId exists in database
        const headers = new HttpHeaders({'Content-Type':  'application/json'});
        let options =  {headers: headers};
        var url = ApiEndpoints.EXISTS_NET_ID;
        var body: any = {
          "virtId": "0",
          "netId": inputNetId
        };
        this.http.post<any>(url, body, options).subscribe(
            data => {
              this.netIdExist = data.response;
              if (this.netIdExist == true) {
                this.hasError = true;
              } else {
                this.hasError = false;
              }
            }
          );

        // Verify if exists duplicates
        var prefixLength = parseInt(inputNetId.split("/")[1]);
        var prefix = this.hex2bin(inputNetId.split("/")[0], prefixLength);
        for (let i of this.networkServerModel.netIds) {
          if (prefix == this.hex2bin(i, prefixLength)) {
            this.duplicatesExist = true;
            break;
          } else {
            this.duplicatesExist = false;
          }
          this.duplicateError = this.duplicatesExist;
        }
      }
    }

    // Verify if exist at least one NetId
    this.doNotHaveNetId = false;
    if(this.networkServerModel.netIds.length == 0 && inputNetId == "" && !this.networkServerModel.nsGroupId) {
      this.doNotHaveNetId = true;
    } else {
      this.doNotHaveNetId = false;
    }
  }

  checkNetId(inputNetId) {
      if(this.networkServerModel.netIds.length == 0 && inputNetId == "") this.renderNsGroup = true;
      else this.renderNsGroup = false;
  }

  addNetId() {
    if(this.inputNetId) {
      let netId = this.inputNetId.nativeElement.value;
      if (netId != '') {
        if(netId.split("/").length == 1) netId = netId + '/24'
        this.networkServerModel.addNetId(netId);
        let index = this.networkServerModel.netIds.length - 1;

        this.trackingArr[index] = this.netIdExist;
        this.trackingCheck[index] = this.duplicatesExist;
        this.trackingPattern[index] = this.patternError;
        this.validateId(netId, index);
        this.noValid = this.netIdExist = this.hasError = this.duplicatesExist = this.doNotHaveNetId = false;
        this.renderNsGroup = false;
        this.inputNetId.nativeElement.value = ''
      }
    }
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  editNetId(index, event) {
    this.networkServerModel.editNetId(index, event.target.value);
    if(this.networkServerModel.netIds.length == 0) this.renderNsGroup = true;
    else this.renderNsGroup = false;
  }

  removeNetId(firstInput, index) {
    this.noValid = this.netIdExist = this.hasError = this.duplicatesExist = this.disableSaveButton = this.patternError = this.doNotHaveNetId = false;
    this.trackingArr.splice(index, 1);
    this.trackingPattern.splice(index, 1);
    this.trackingCheck.splice(index,1);
    this.networkServerModel.removeNetId(index);
    for(let validateIndex = 0; validateIndex <= this.trackingCheck.length; validateIndex++){
      if (this.trackingCheck[validateIndex] === true) {
        this.validateId(this.networkServerModel.netIds[validateIndex], validateIndex);
      }
    }
    for(let validateIndex = 0; validateIndex <= this.trackingArr.length; validateIndex++){
      if (this.trackingArr[validateIndex] === true) {
        this.validateId(this.networkServerModel.netIds[validateIndex], validateIndex);
      }
    }
    for(let validateIndex = 0; validateIndex <= this.trackingPattern.length; validateIndex++){
      if (this.trackingPattern[validateIndex] === true) {
        this.validateId(this.networkServerModel.netIds[validateIndex], validateIndex);
      }
    }
    if(this.networkServerModel.netIds.length == 0 && firstInput == "") this.renderNsGroup = true;
    if(this.networkServerModel.netIds.length == 0 && firstInput == "" && !this.networkServerModel.nsGroupId) {
      this.doNotHaveNetId = true;
    }
  }

  validateUrl(urlValue, inputElement){

    if(this.networkServerModel.url_fns != "" || this.networkServerModel.url_sns != "" || this.networkServerModel.url_hns != "") {
      this.haveUrl = true;
    }
    else {
      this.haveUrl = false;
    }

    if(urlValue !== ''){
      let idRegExp = new RegExp(/^(([a-zA-Z-][a-zA-Z0-9-]{1,63}(\.[a-zA-Z-][a-zA-Z0-9-]{1,63})+)|((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])\b))(\:(102[4-9]|10[3-9][0-9]|1[1-9][0-9][0-9]|[2-9][0-9][0-9][0-9]|[1-5][0-9][0-9][0-9][0-9]|6[0-4][0-9][0-9][0-9]|65[0-4][0-9][0-9]|655[0-2][0-9]|6553[0-5])\b)?(((\/){0,1}[a-zA-Z-0-9\_\-])*(::)?([a-zA-Z-0-9\_\-])*)*(\/){0,1}$/);

      if (!idRegExp.test(urlValue)) {
        if(inputElement.id == 'url_fns') {
          this.fnsPatternError = true;
        } else if(inputElement.id == 'url_sns'){
          this.snsPatternError = true;
        } else {
          this.hnsPatternError = true;
        }
        inputElement.classList.remove(...this.class);
      } else {
        if(inputElement.id == 'url_fns') {
          this.fnsPatternError = false;
        } else if(inputElement.id == 'url_sns'){
          this.snsPatternError = false;
        } else {
          this.hnsPatternError = false;
        }
        inputElement.classList.add(...this.class);
      }
    } else {
      inputElement.classList.remove(...this.class);
      if(inputElement.id == 'url_fns') {
        this.fnsPatternError = false;
      } else if(inputElement.id == 'url_sns'){
        this.snsPatternError = false;
      } else {
        this.hnsPatternError = false;
      }
    }

    if(this.fnsPatternError || this.snsPatternError || this.hnsPatternError){
      this.urlPatternError = true;
    } else {
      this.urlPatternError = false;
    }
  }

  validateParamSetId(paramSetId, paramSetIdElement) {
    this.paramSetIdExist = false;
    paramSetIdElement.classList.remove(...this.class);
    if(paramSetId.trim().length == 0) {
      paramSetIdElement.classList.remove(this.class);
      paramSetIdElement.classList.add(this.errorClass);
    } else {
      this.rfParamSets.forEach(element => {
        if(element.RFParamSetID === paramSetId) this.paramSetIdExist = true
      });
      if(this.paramSetIdExist) paramSetIdElement.classList.add(...this.errorClass)
      else paramSetIdElement.classList.add(...this.class);
    }
  }

  validateActilityRfParamSet(actilityRfParamSet, actilityRfParamSetElement) {
    if(actilityRfParamSet.trim().length == 0) {
      actilityRfParamSetElement.classList.remove(this.class);
      actilityRfParamSetElement.classList.add(this.errorClass);
    } else {
      actilityRfParamSetElement.classList.add(...this.class)
    }
  }

  fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      var file: any = fileInput.target.files[0];
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.rfParamSetElement.ActilityRFParamSet =  reader.result.toString();
      }
      reader.readAsText(file);
    }
  }

  addRFParamSetElement() {
    this.rfParamSets.push(this.rfParamSetElement)
    this.rfParamSetElement = new RFParamSetElement();
    this.rfParamSetPanelHidden = true;
  }

  removeRFParamSetElement(itemToRemove: RFParamSetElement) {
    this.rfParamSets.forEach( (item, index) => {
      if(item === itemToRemove) this.rfParamSets.splice(index,1);
    });
  }

  showAddRFParamSetPanel() {
    this.rfParamSetPanelHidden = false;
  }

  getAllOwnerWithSearch() {
    this.showSearch = true;
    var url = ApiEndpoints.GET_ALL_USERS;
    var body = {
      "username": ""
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            if(index.isHidden == undefined || index.isHidden == "false") {
              this.ownerArray.push(index.username + ", " + index.firstName + " " + index.lastName);
            }
          }
        }
      );
  }

  // Get AllPrimaryHub Call Function

  getPlatform() {
    this.showPrimarySearch = true;
    var url = ApiEndpoints.PLATFORMS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<Array<any>>(url, options)
      .subscribe(
        data => {
          for(let index of data){
            this.allPlatforms.push(index.platformId + ", " + index.platformName);
          }
        }
      );
  }

  // Get AllNsGroups Call Function
  getNsGroups() {
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVER_GROUPS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<Array<any>>(url, options).subscribe(
        data => {
          for(let index of data){
            let devAddrRange = DevAddrUtils.getDevAddrRangeFromNetID(index.netIds[0].split("/")[0]);
            this.allNsGroups.push(index.virtId + ", " + index.name + ", " + devAddrRange);
          }
        }
      );
  }

  getNsGroup(virtId: string) {
    var url = ApiEndpoints.GET_NETWORK_SERVER_GROUP;
    const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var body: any = {
      "virtId": virtId
    };
    this.http.post<any>(url, body, options).subscribe(
      data => {
         this.networkServerModel.netIds = data.netIds;
      });
  }

  validateSubnwkId(inputCheck, inputElement, event: any) {
    this.subnwkIdExist = this.noValidSubnwkId = this.hasError = this.subnwkIdOutOfRange = false;
    this.doNotHaveSubnwkId = true;
    let subnwkIdRegExp = new RegExp(/^([0-9a-fA-F]{8})(\/([0-9]|1[0-9]|2[0-4]))?$/i);
    var subnwkId = inputCheck;
    if(!subnwkIdRegExp.test(subnwkId)) {
      this.noValidSubnwkId = true;
      this.hasError = true;
    } else {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      });
      let options =  {headers: headers};
      subnwkId = this.addSuffix(subnwkId);
      let convertedSubnwkId: string;
      try {
        convertedSubnwkId = DevAddrUtils.getSubnetRangeFromDevAddrRange(subnwkId, this.networkServerModel.netIds[0].split("/")[0]);
      } catch (e) {
        this.subnwkIdOutOfRange = true;
        this.hasError = true;
        return;
      }
      var url = ApiEndpoints.EXISTS_SUBNWKID;
      var body: any = {
        "nsGroupId": this.networkServerModel.nsGroupId,
        "virtId": "0",
        "subnwkId": convertedSubnwkId
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.subnwkIdExist = data.response;
            if (this.subnwkIdExist == true) {
              this.hasError = true;
            } else {
              this.doNotHaveSubnwkId = false;
            }
          }
        );
    }
  }


  //Validate Alarm threshold

  // validateAlarm(alarmValue, alarmElement){
  //   if(alarmValue !== "") {
  //     this.validAlarm = true;
  //     this.errorValidAlarm = false;
  //
  //     let idRegExp = new RegExp('^[1-9][0-9]*$');
  //     if (!idRegExp.test(alarmValue)) {
  //       this.patternAlarm = false;
  //       this.errorPatternAlarm = true;
  //       alarmElement.classList.remove(...this.class);
  //       alarmElement.classList.add(...this.errorClass);
  //
  //     } else {
  //       this.patternAlarm = true;
  //       this.errorPatternAlarm = false;
  //       alarmElement.classList.remove(...this.errorClass);
  //       alarmElement.classList.add(...this.class);
  //     }
  //   } else {
  //     alarmElement.classList.remove(...this.class);
  //     alarmElement.classList.add(...this.errorClass);
  //     this.patternAlarm = false;
  //     this.errorPatternAlarm = false;
  //     this.validAlarm = false;
  //     this.errorValidAlarm = true;
  //   }
  // }

  saveNetworkServer() {
    this.networkServerModel.name = this.networkServerModel.name.trim();
    this.networkServerModel.rfParamSets = this.rfParamSets;
    if(!this.doNotHaveSubnwkId) {
      try {
        this.networkServerModel.subnwkId = DevAddrUtils.getSubnetRangeFromDevAddrRange(this.networkServerModel.subnwkId, this.networkServerModel.netIds[0].split("/")[0]);
      } catch (e) {
        this.subnwkIdOutOfRange = true;
        this.hasError = true;
        return;
      }
    }
    if(this.renderNsGroup) this.networkServerModel.netIds = [];
    var body: any = JSON.parse(JSON.stringify(this.networkServerModel));
    var url = ApiEndpoints.CREATE_NETWORK_SERVER;
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.router.navigate(['/all-network']);
        }
      );
  }

  backClicked() {
    this._location.back();
  }

  cancelAddRFParamSetElement() {
    this.rfParamSetPanelHidden = true;
  }

  ngOnInit() {
    // Get AllPrimaryHub Call
    this.getNsGroups();
    this.getPlatform();
    this.getAllOwnerWithSearch();
    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
  }

  private addSuffix(id: any): any {
    if (id && id !== '') {
      if (id.split('/').length === 1) {
        if (id.length === 6) {
          id += '/24';
        }
      }
    }
    return id;
  }

  private removeSuffix(id: any): any {
    if (id && id !== '') {
      const splitted = id.split('/');
      if (splitted.length !== 1 && splitted[1] === '24') {
        id = splitted[0];
      }
    }
    return id;
  }

}
